import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Typography, TextField, Grid } from '@mui/material';
import { isModalOpen, setToastMessage } from '../redux/FlowReducer';
import VariableAutocomplete from '../VariableAutocomplete';
import PanelShell from './PanelShell';

const SMSPropertyPanel = ({ nodeType, nodeId, data, onChange }) => {
  const dispatch = useDispatch();
  const [phoneNumber, setPhoneNumber] = useState(data?.phoneNumber || data?.to || '');
  const [message, setMessage] = useState(data?.message || '');

  useEffect(() => {
    setPhoneNumber(data?.phoneNumber || data?.to || '');
    setMessage(data?.message || '');
  }, [data]);

  const handleVariableSelect = (event, variable) => {
    if (!variable) return;

    const variableName = variable.displayName || variable.name;

    setMessage(prevMessage => {
      const input = document.getElementById('smsMessage');
      const cursorPosition = input?.selectionStart || prevMessage.length;
      const newMessage =
        prevMessage.slice(0, cursorPosition) +
        `{${variableName}}` +
        prevMessage.slice(cursorPosition);
      return newMessage;
    });
  };

  if (nodeType !== 'SMS') return null;

  const handleSave = () => {
    const updatedData = {
      ...data,
      phoneNumber,
      to: phoneNumber, // Keep to for backward compatibility
      message,
      Title: `SMS: ${phoneNumber}`,
      label: 'SMS',
      icon: 'sms-icon',
    };

    onChange(updatedData);
    dispatch(isModalOpen());
    dispatch(setToastMessage({ type: 'success', message: 'SMS ayarları kaydedildi.' }));
  };

  return (
    <PanelShell title="SMS Gönder" onSave={handleSave}>
      <Grid container spacing={2} sx={{ maxWidth: '100%', overflow: 'hidden' }}>
        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} mb={1} color="text.secondary">
            Telefon Numarası
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="+90..."
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} mb={1} color="text.secondary">
            Mesaj
          </Typography>
          <TextField
            id="smsMessage"
            fullWidth
            size="small"
            multiline
            rows={6}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Mesaj içeriği... Aşağıdan değişken seçerek ekleyebilirsiniz"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} mb={1} color="text.secondary">
            Mesaja Değişken Ekle
          </Typography>
          <VariableAutocomplete
            value={null}
            onChange={handleVariableSelect}
            placeholder="Tag ve değişken ara..."
            showConstants={false}
          />
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
            Seçilen değişkenler mesaja {'{değişken_adı}'} formatında eklenecektir
          </Typography>
        </Grid>
      </Grid>
    </PanelShell>
  );
};

export default SMSPropertyPanel;
